import { Stack } from '@mantine/core';
import { ReactNode } from 'react';

interface DataBoxLayoutProps {
  sections?: ReactNode[][];
  tableSections?: ReactNode[];
  tablePosition?: 'top' | 'bottom';
}

export function DataBoxLayout({ sections, tableSections, tablePosition = 'bottom' }: DataBoxLayoutProps) {

  const renderTableSections = () =>
    tableSections?.length ? (

      <div className='data-box-table'>
        <Stack w='100%'>
          {tableSections.map((table, index) => (
            <div key={index} className='data-box-section'>
              {table}
            </div>
          ))}
        </Stack>
      </div>

    ) : null;

  return (
    <div className='data-box'>
      {tablePosition === 'top' && renderTableSections()}
      {sections?.map((section, index) => (
        <div key={index} className='data-box-row'>
          {section?.map((innerSection, index) => (
            <div key={index} className='data-box-section'>
              {innerSection}
            </div>
          ))}
        </div>
      ))}
      {tablePosition === 'bottom' && renderTableSections()}
    </div>
  );
}